import { useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faHeart, faPlusCircle, faVideo } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from 'react-router-dom'
import { useGetExercisesQuery, useAddNewFavoriteMutation, useDeleteFavoriteMutation } from "./exercisesApiSlice"
import { memo } from 'react'
import { toast } from 'react-toastify'


const Exercise = ({ exerciseId, favorites, userId, isMobile }) => {

    const navigate = useNavigate()

    // get exercise data
    const { exercise } = useGetExercisesQuery("exercisesList", {
        selectFromResult: ({ data }) => ({
            exercise: data?.entities[exerciseId]
        }),
    })

    // see if exercise is a favorite
    const IsVisible = favorites.filter(item => exerciseId === item.exercise_id).length>0
    let icon = IsVisible ? faHeart: faPlusCircle
    let iconClass = IsVisible ? 'fa-icon text-success' : 'fa-icon'

    // add or delete favorite
    const [addNewFavorite, {
        isError,
        error
    }] = useAddNewFavoriteMutation()

    const [deleteFavorite, {
        isError: delIsError,
        error: delError
    }] = useDeleteFavoriteMutation()

    useEffect(() => {
        if (isError) {
            toast.error(error?.data?.message);
        }
        if (delIsError) {
            toast.error(delError?.data?.message);
        }
    }, [isError, error, delIsError, delError])


    
    const onFavoriteClicked = async () => {
        if (IsVisible) {
            // delete favorite
            await deleteFavorite({ exerciseID: exerciseId, userID: userId })
        } else {
            // add favorite
            await addNewFavorite({ exerciseID: exerciseId, userID: userId })
        }
    }
    


    // show the row
    if (exercise) {
        const handleEdit = () => navigate(`/dash/exercises/${exerciseId}`)
        const handleVideo = (url) => {
            window.open(url, "_blank", "noreferrer")
        }

        let videoButton=null
        if (exercise.video) {
            videoButton=
            <span 
                target="_blank" rel="noreferrer" 
                onClick={ ()=> handleVideo(exercise.video) } 
                className="text-steel icon p-2" 
                role="button" 
                style={{marginLeft: "10px"}}
                title="Watch this exercise"
            >
                <FontAwesomeIcon icon={faVideo} className="fa-icon"/>
            </span>
        }

        return (
            <tr>
                <td style={{ width: isMobile ? '60%' : '40%'}}>
                    <FontAwesomeIcon icon={icon}  className={iconClass} style={{marginRight: '10px'}}  onClick={onFavoriteClicked}  />
                    {isMobile===true ? exercise.exercise_name.substr(0,15)+'...' : exercise.exercise_name.substr(0,40)+'...'}
                </td>
                {isMobile === false && <td style={{ width: '20%'}}>{exercise.exercisetype}</td>}
                {isMobile === false && <td style={{ width: '20%'}} >{exercise.bodypart}</td>}
                <td >
                    <span
                        className="text-secondary icon p-2"
                        role="button"
                        onClick={handleEdit}
                        title="Edit this exercise"
                    >
                        <FontAwesomeIcon icon={faPenToSquare}  className="fa-icon"/>
                    </span>
                    {videoButton}
                </td>
            </tr>
        )

    } else return null
}

const memoizedExercise = memo(Exercise)

export default memoizedExercise